import PropTypes from 'prop-types'
import { compose, setDisplayName, withHandlers, pure } from 'recompose'
import { get, find, isArray } from 'lodash'

import { PLACEMENT_POSITIONS } from 'utils/constants/components/popover'
import { LIST_SIZES, LIST_TYPES } from 'utils/constants/components/dropdown'
import { DropdownInfiniteListView } from 'components/dropdown/infiniteList/DropdownInfiniteListView'

const handleIsRowSelected =
  ({ value, isRowSelectedFn }) =>
  ({ item }) => {
    if (!isRowSelectedFn) {
      return isArray(value) ? !!find(value, { id: get(item, 'id') }) : get(value, 'id') === get(item, 'id')
    }

    return isRowSelectedFn({ item })
  }

export const DropdownInfiniteList = compose(
  setDisplayName('DropdownInfiniteList'),
  pure,
  withHandlers({
    handleIsRowSelected,
  }),
)(DropdownInfiniteListView)

DropdownInfiniteList.propTypes = {
  // common
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(LIST_SIZES),
  titleKey: PropTypes.string,
  type: PropTypes.oneOf(LIST_TYPES),

  // dropdown
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  headerRenderer: PropTypes.func,
  onClose: PropTypes.func,
  placement: PropTypes.oneOf(PLACEMENT_POSITIONS),
  triggerClassName: PropTypes.string,
  triggerElementRenderer: PropTypes.func,
  width: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  // trigger
  isDisabled: PropTypes.bool,
  isValid: PropTypes.bool,
  multiSelectTitle: PropTypes.string,
  placeholder: PropTypes.string,

  // list
  closeOnSelect: PropTypes.bool,
  emptyMessage: PropTypes.string,
  height: PropTypes.number,
  isEmptyStateIconShown: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isRowSelectedFn: PropTypes.func,
  listItems: PropTypes.array,
  listMaxHeight: PropTypes.number,
  listMeta: PropTypes.object,
  noRowGutter: PropTypes.bool,
  onLoadMore: PropTypes.func,
  onRowClick: PropTypes.func,
  rowHeight: PropTypes.number,
  rowRenderer: PropTypes.func,
  totalCount: PropTypes.number,

  // footer
  error: PropTypes.string,
  errorClassName: PropTypes.string,
  footerRenderer: PropTypes.func,
  showErrorText: PropTypes.bool,

  // reposition
  keysToPositionUpdate: PropTypes.array,
}
